module.exports = __webpack_public_path__ + "static/media/logo-otwr-scaled.c407f163.png";